export const BACK_TO_RESULTS = "Back to results";

export const CHOOSE_ROOM = "Choose Room";
